import React from 'react'

import { css } from '@emotion/react'
import { rgba } from 'polished'
import { colors } from 'shared-ui'


const Input = props => (
    <input
        css={css`
            background: ${colors.eventLight} !important;
            color: ${colors.white} !important;
            font-size: 0.9375em;
            padding: 1.25em;
            &::placeholder {
                color: ${rgba(colors.white, 0.5)} !important;
            }
            outline: none;
            border: none;
        `}
        {...props}
    />
)

/**
 * @param {{
 *  autoFocus?: boolean,
 *  className?: string,
 *  type?: string,
 *  value?: string,
 *  onChange?: () => void,
 *  maxLength?: number,
 *  disabled?: boolean,
 *  css?: import('@emotion/react').CSSObject
 * }} 
 */

export default function TextField({autoFocus, className, type = 'text', ...props }) {
    return (
        <Input
            autoFocus={autoFocus}
            className={className}
            type={type}
            {...props}
        />
    )
}